import { DeliveryForecastItemSplit } from '../../../../../../../../data/models'

export function isRejectButtonDisabled(
  items?: DeliveryForecastItemSplit[] | null,
): boolean {
  // If no items are selected disable the button
  if (!items?.length) {
    return true
  }

  // Check if every item is rejected if so disabled the button
  const isModifiedOrRejected = items?.every(
    item => item.Status === 'REJECTED' || item.Status === 'ADDED',
  )

  return isModifiedOrRejected
}
